// import * as StringTools from '~/utilities/string'
import { validatePhoneNumber } from '~/services/utility'
import EmailValidation from '~/utilities/emailValidation'
import * as PhoneNumberTools from '~/utilities/phoneNumber'

const passwordValidation = value => {
  const passwordLength = value.trim().length
  if (!value || !passwordLength) return 'A password is required.'
  if (passwordLength <= 3) {
    return 'Password is not long enough'
  }
  return false // no problems
}

const USER_VALIDATIONS = {
  password: passwordValidation,
  passwordConfirmation: passwordValidation,
  firstName: value => {
    const firstNameLength = value.trim().length
    if (!firstNameLength) return 'First name is required.'
    if (firstNameLength < 2)
      return 'First name should be at least two characters long.'
    return false // no problems
  },
  lastName: value => {
    const lastNameLength = value.trim().length
    if (!lastNameLength) return 'Last name is required.'
    if (lastNameLength < 2)
      return 'Last name should be at least two characters long.'
    return false // no problems
  },
  name: value => {
    const fullName = value.trim().split(' ')
    const nameLength = fullName.length
    if (fullName.find(n => n.length < 2))
      return 'Each name should be at least two characters long.'
    if (!nameLength) return 'Name is required.'
    if (nameLength < 2) return 'First and last name are required.'
    if (nameLength >= 3) return 'Enter only your first and last name.'
    return false
  },
  username: value => {
    const emailLength = value.trim().length
    if (!value || !emailLength) return 'Email is required.'
    if (!EmailValidation(value)) return 'Please enter a valid email.'
    return false // no problems
  },
  email: value => {
    const emailLength = value.trim().length
    if (!value || !emailLength) return 'Email is required.'
    if (!EmailValidation(value)) return 'Please enter a valid email.'
    return false // no problems
  },
  phoneNumber: value => {
    return PhoneNumberTools.isValid(value)
      ? false
      : 'Please enter a valid phone number.'
  },
  licenseID: value => {
    // REMOVED FOR FLOW UPDATES
    // const licenseIDLength = value.trim().length
    // if (!value || !licenseIDLength) return 'A license ID number is required.'
    // if (!value.match(/^\w{5,20}$/)) {
    //   return 'A license ID must be 5 to 20 alphanumeric characters.'
    // }
    return false // no problems
  },
  licenseState: value => {
    // REMOVED FOR FLOW UPDATES
    // if (!value) return 'Please select which state issued your drivers license.'
    return false // no problems
  },
  address: value => {
    if (!value) return 'An address is required'
    const address = value.trim()
    if (!address.length || address.length < 3) return 'Address is too short.'
    return false // no problems
  },
  city: value => {
    if (!value) return 'City is required'
    const city = value.trim()
    if (!city.length || city.length < 2) return 'City is too short.'
    return false // no problems
  },
  zipcode: value => {
    if (!value) return 'Zipcode is required'
    const zipcode = value.trim()
    if (!zipcode.length || zipcode.length < 5) return 'Zip code is too short.'
    return false // no problems
  },
  countryState: value => {
    if (!value) return 'State is required'
    const state = value.trim()
    if (!state.length || state.length < 2) return 'State is not valid.'
    return false // no problems
  }
}

export const USER_ASYNC_VALIDATIONS = {
  phoneNumber: async (phoneNumber) => {
    const errorMessage = 'Only US phone numbers are allowed.'
    
    try {
      const { valid } = await validatePhoneNumber(phoneNumber)

      return valid ? false : errorMessage
    } catch (error) {
      return errorMessage
    }
  }
}


export default USER_VALIDATIONS
